import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-product-card-core-skeleton',
  imports: [
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './product-card-core-skeleton.component.html',
  styleUrls: ['./product-card-core-skeleton.component.scss', '../product-card-core.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardCoreSkeletonComponent {
  public displayListView: InputSignal<boolean> = input(false);
  public wrapperClass: Signal<string> = computed(() => 'wrapper-core-' + (this.displayListView() ? 'list' : 'grid'));
}
